import { render } from "./Coupon.vue?vue&type=template&id=2aebddb0&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"

import "./Coupon.vue?vue&type=style&index=0&id=2aebddb0&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aebddb0"]])

export default __exports__